import React from 'react';
import LayoutC from '../LayoutC';

const LayoutB = props => {
  return (
    <LayoutC
      singleColumnWidth={4}
      columnWithItemsWidth={8}
      rowElementsWidth={4}
      availableSlots={10}
      {...props}
    />
  );
};

export default LayoutB;
